import React, { useId, useState } from 'react';
import { useIntl } from "react-intl";
import { ScenarioCreate } from "@/model";
import { useCreateScenario } from "@/query/scenario";
import { useModal, useRouteHandler } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";
import { Textarea, TextInputGroup } from "@/component/input";


export const SCENARIO_CREATE_MODAL_ID = "scenario-create-Modal-id";

const ScenarioCreateModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const { moveToDashboard } = useRouteHandler();
    const descriptionId = useId();

    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");

    const { mutateAsync: createScenario, isPending: isCreating } = useCreateScenario();

    const submit = async () => {
        const form: ScenarioCreate = {
            name: name.trim(),
            description: description.trim()
        };
        if (!form.name) {
            return;
        }
        createScenario(form)
            .then((newScenario) => {
                successToast(intl.formatMessage({ id: "t001" }));
                modal.close(SCENARIO_CREATE_MODAL_ID);
                moveToDashboard(newScenario.id);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    const onClickCancel = (e: React.MouseEvent) => {
        e.preventDefault();
        modal.close(SCENARIO_CREATE_MODAL_ID);
    };

    const onClickConfirm = async (e: React.MouseEvent) => {
        e.preventDefault();
        await submit();
    };

    return (
        <Modal id={SCENARIO_CREATE_MODAL_ID}
               size="md"
               title={intl.formatMessage({ id: "i00023" })}
               onClose={() => {
                   setName("");
                   setDescription("");
               }}
        >
            <div className="modal-body">
                <div className="modal-description flex flex-col gap-6">
                    <TextInputGroup required
                                    useDirty
                                    defaultValue=""
                                    label={intl.formatMessage({ id: "b0050" })}
                                    aria-label={intl.formatMessage({ id: "b0050" })}
                                    placeholder={intl.formatMessage({ id: "i00024" })}
                                    onChange={setName}
                    />
                    <div className="flex flex-col gap-1.5">
                        <label htmlFor={descriptionId}
                               className="modal-input-group-heading"
                        >
                            {intl.formatMessage({ id: "i00025" })}
                        </label>
                        <Textarea id={descriptionId}
                                  rows={4}
                                  className="modal-input"
                                  value={description}
                                  placeholder={intl.formatMessage({ id: "i00026" })}
                                  onChange={setDescription}
                        />
                    </div>
                </div>

                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            onClick={onClickCancel}
                            disabled={isCreating}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            onClick={onClickConfirm}
                            disabled={isCreating || !name.trim()}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ScenarioCreateModal;
